export const SEARCH_ENGINE = {
    DESKTOP_FIRST_COLUMN_WIDTH: '444px',
    LISTING_MAX_WIDTH: 'calc(1320px - 3rem)',
    MAP_SEARCH_FIRST_COLUMN_WIDTH: '340px',
    MAX_WIDTH: '1038px',
    MAX_PICKER_WIDTH: '270px',
    IS_MOBILE_SSR_BREAKPOINT: '1250px',
};
